export function getFedexTrackingUrl(trackingNumber: string) {
  return `https://www.fedex.com/apps/fedextrack?trknbr=${trackingNumber}`
}
